ixModuleRouting("impactx.usergroups", {
    "/usergrouplist": {
        template: "<ixa-user-group-list></ixa-user-group-list>",
        templateUrl: "modules/usergroups/templates/usergrouplist.html",
        process: "ListUserGroups",
        controller: "UserGroupListController",
        controllerAs: "userGroupListController",
        workspace: "admin",
    },
    "/usergroup/:id": {
        template: "<ixa-user-group-dialog></ixa-user-group-dialog>",
        templateUrl: "modules/usergroups/templates/usergroupdetails.html",
        process: "EditUserGroups",
        controller: "EditUserGroupController",
        controllerAs: "editUserGroupController",
        workspace: "admin",
    },
    "/usergroup/catalogright/:id": {
        template: "<ixa-user-group-catalogright-dialog></ixa-user-group-catalogright-dialog>",
        templateUrl:
            "modules/usergroups/templates/usergroupcatalogrightdetails.html",
        process: "EditUserGroups",
        controller: "EditUserGroupCatalogRightController",
        controllerAs: "catRightController",
        workspace: "admin",
    },
});
